import {
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/Encoding.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonEncoderClass;
function JsonEncoder() {
  if (JsonEncoderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'JsonEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    JsonEncoderClass = $;
  }
  return JsonEncoderClass;
}
//region block: exports
export {
  JsonEncoder as JsonEncoder1qlse6simkfi1,
};
//endregion

//# sourceMappingURL=JsonEncoder.mjs.map
